
import { Injectable, inject, DOCUMENT } from '@angular/core';
import { SwUpdate, VersionEvent } from '@angular/service-worker';
import { filter } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppUpdateService {
  private readonly document = inject(DOCUMENT);
  private readonly updates = inject(SwUpdate);
  private started = false;

  start(): void {
    if (!this.updates.isEnabled || this.started) {
      return;
    }

    this.started = true;
    this.updates.versionUpdates
      .pipe(filter((event: VersionEvent) => event.type === 'VERSION_READY'))
      .subscribe(() => {
        const shouldReload = this.document.defaultView?.confirm(
          'Une nouvelle version de LifeOps est disponible. Recharger maintenant ?'
        );

        if (shouldReload) {
          void this.activateAndReload();
        }
      });
  }

  private async activateAndReload(): Promise<void> {
    await this.updates.activateUpdate();
    this.document.defaultView?.location.reload();
  }
}
